"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchVariantsCommand = void 0;
const AbstractFilteredVariantsCommand_1 = require("./AbstractFilteredVariantsCommand");
class SearchVariantsCommand extends AbstractFilteredVariantsCommand_1.AbstractFilteredVariantsCommand {
    async exec() {
        var _a, _b;
        let variants;
        const url = `/applications/${this.appId}${((_a = this.filter) === null || _a === void 0 ? void 0 : _a.type) ? '/' + this.filter.type : ''}`;
        const response = await this.api.get(url, {
            validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
        });
        if (response.status === 404) {
            return [];
        }
        const res = response.data;
        if ((_b = this.filter) === null || _b === void 0 ? void 0 : _b.type) {
            // ensure that returned object is an array
            variants = res.filter ? res : [res];
        }
        else {
            // get all variants
            const _variants = res.variants || [];
            // ensure that returned object is an array
            variants = _variants.filter ? _variants : [_variants];
        }
        return this.applyVariantFilter(variants);
    }
}
exports.SearchVariantsCommand = SearchVariantsCommand;
//# sourceMappingURL=SearchVariantsCommand.js.map